module.exports = __webpack_public_path__ + "img/blurred-login-background.790f91af.png";